import { render, staticRenderFns } from "./leitungsEditor.vue?vue&type=template&id=58b07019&"
import script from "./leitungsEditor.vue?vue&type=script&lang=js&"
export * from "./leitungsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports